/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CreatePoolCoinAddressRequest } from './create-pool-coin-address-request';


export interface CreatePoolRequest { 
    name?: string | null;
    coinAddresses?: Array<CreatePoolCoinAddressRequest> | null;
}

